// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cartogram-legends {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

  .cartogram-legends-form {
    height: 100%;
  }

  .cartogram-legends__header-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
  }

  .cartogram-legends .cartogram-legends__title {
    margin: 0;
  }

  .cartogram-legends__settings-card {
    max-height: 100%;
    overflow: auto;
  }

  .cartogram-legends__settings-card__separator {
      margin: 8px 0px;
    }

  .cartogram-legends__settings-card .ant-card-body {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 8px;
    }

  .cartogram-legends__settings {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-right: 30px;
  }

  .cartogram-legends__settings .cartogram-legends__settings__item {
      width: 100%;
      margin: 0px;
    }

  .cartogram-legends__settings__range {
      display: flex;
      justify-content: space-between;
      gap: 8px;
      align-items: flex-start;
    }

  .cartogram-legends__settings__add-button {
      padding: 0px;
      width: -moz-fit-content;
      width: fit-content;
    }

  .cartogram-legends__settings .cartogram-legends__settings__close-button {
      position: absolute;
      right: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }
`, "",{"version":3,"sources":["webpack://./src/components/Module/Cartograms/components/CartogramMapLegend/style.scss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AAkEV;;EAhEE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAYhB;;EAVE;MACE,eAAe;IACjB;;EAEA;MACE,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,YAAY;IACd;;EAGF;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;EA0BrB;;EAxBE;MACE,WAAW;MACX,WAAW;IACb;;EAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,QAAQ;MACR,uBAAuB;IACzB;;EAEA;MACE,YAAY;MACZ,uBAAkB;MAAlB,kBAAkB;IACpB;;EAEA;MACE,kBAAkB;MAClB,QAAQ;MACR,MAAM;MACN,WAAW;MACX,YAAY;IACd","sourcesContent":[".cartogram-legends {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  &-form {\n    height: 100%;\n  }\n\n  &__header-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n  }\n\n  & &__title {\n    margin: 0;\n  }\n\n  &__settings-card {\n    max-height: 100%;\n    overflow: auto;\n\n    &__separator {\n      margin: 8px 0px;\n    }\n\n    .ant-card-body {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      padding: 8px;\n    }\n  }\n\n  &__settings {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding-right: 30px;\n\n    & &__item {\n      width: 100%;\n      margin: 0px;\n    }\n\n    &__range {\n      display: flex;\n      justify-content: space-between;\n      gap: 8px;\n      align-items: flex-start;\n    }\n\n    &__add-button {\n      padding: 0px;\n      width: fit-content;\n    }\n\n    & &__close-button {\n      position: absolute;\n      right: 0;\n      top: 0;\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
